import { FormValues as IntroductionFormValues } from '../../../shared/TileIntroductionForm/types';
import { setAttendanceSkipIntroduction } from '../../../../db/classes';
import { useCallback } from 'react';
import { useAppContext } from '../../../../app/Context';
import { useTranslation } from 'react-i18next';
import { i18nNS } from '../../../../i18n';
import { SlideType } from '../../../../db/shared/types';
import { setActivityType } from '../../../../db/shared';
import routes from '../../../../routes/router';

export interface UseAttendanceSteps {
  goToNextStep: () => void;
}

const useAttendanceSteps = ({ goToNextStep }: UseAttendanceSteps) => {
  const { t } = useTranslation([i18nNS.COMMON, i18nNS.TIMER]);

  const { presentationId, activeSlideId, setSlideTitleAndSubtitle } = useAppContext();

  const handleGotoAttendance = useCallback(() => {
    if (!presentationId) return;
    if (!activeSlideId) return;

    setSlideTitleAndSubtitle({
      title: t('acadly_activity_plugin', { ns: i18nNS.COMMON }),
      subtitle: t('attendance_was_not_recorded', { ns: i18nNS.CLASS }),
    });
    const attendanceUrl = routes.attendance.url();
    setActivityType(presentationId, activeSlideId, SlideType.ATTENDANCE, attendanceUrl);

    goToNextStep();
  }, [presentationId, activeSlideId, setSlideTitleAndSubtitle, goToNextStep]);

  const handleClickIntroductionNext = (data: IntroductionFormValues) => {
    setAttendanceSkipIntroduction(data.doNotShowAgain);
    handleGotoAttendance();
  };

  return {
    handleClickIntroductionNext,
    handleGotoAttendance,
  };
};

export default useAttendanceSteps;
